import React from "react";
import SurveyIcon from "../../Icon/Survey";
import SettingsIcon from "../../Icon/Settings";
import RecentItemsIcon from "../../Icon/RecentItems";
import PersonAccountIcon from "../../Icon/PersonAccount";
import PaperIcon from "../../Icon/Paper";
import PagesIcon from "../../Icon/Pages";
import MessageBubblesIcon from "../../Icon/MessageBubbles";
import MailIcon from "../../Icon/Mail";
import MegaphoneIcon from "../../Icon/Megaphone";
import LogOutIcon from "../../Icon/LogOut";
import InfoIcon from "../../Icon/Info";
import HotelIcon from "../../Icon/Hotel";
import HelpCircleIcon from "../../Icon/HelpCircle";
import ExportIcon from "../../Icon/Export";
import EventIcon from "../../Icon/Event";
import DashboardIcon from "../../Icon/Dashboard";
import ContactsIcon from "../../Icon/Contacts";
import CalendarIcon from "../../Icon/Calendar";
import BarGraphVerticalIcon from "../../Icon/BarGraphVertical";
import VideoIcon from "../../Icon/Video";
import UserIcon from "../../Icon/User";
import UsersIcon from "../../Icon/Users";
import ComputerIcon from "../../Icon/Computer";
import PieChartIcon from "../../Icon/PieChart";
import MapPinIcon from "../../Icon/MapPin";
import UtencilsIcon from "../../Icon/Utencils";
import SearchIcon from "../../Icon/Search";
var ICONS = {
    BarGraphVerticalIcon: BarGraphVerticalIcon,
    CalendarIcon: CalendarIcon,
    ComputerIcon: ComputerIcon,
    ContactsIcon: ContactsIcon,
    DashboardIcon: DashboardIcon,
    EventIcon: EventIcon,
    ExportIcon: ExportIcon,
    HelpCircleIcon: HelpCircleIcon,
    HotelIcon: HotelIcon,
    InfoIcon: InfoIcon,
    LogOutIcon: LogOutIcon,
    MailIcon: MailIcon,
    MapPinIcon: MapPinIcon,
    MegaphoneIcon: MegaphoneIcon,
    MessageBubblesIcon: MessageBubblesIcon,
    PagesIcon: PagesIcon,
    PaperIcon: PaperIcon,
    PersonAccountIcon: PersonAccountIcon,
    PieChartIcon: PieChartIcon,
    RecentItemsIcon: RecentItemsIcon,
    SearchIcon: SearchIcon,
    SettingsIcon: SettingsIcon,
    SurveyIcon: SurveyIcon,
    UserIcon: UserIcon,
    UsersIcon: UsersIcon,
    UtencilsIcon: UtencilsIcon,
    VideoIcon: VideoIcon
};
export var isIconKey = function(icon) {
    return Object.keys(ICONS).includes(icon);
};
export { ICONS };
